// extracted by mini-css-extract-plugin
export default {"titleContainer":"titleContainer---sjXQ5","sharedIconRoot":"sharedIconRoot---NADfR","sharedIcon":"sharedIcon---a41r1","sharedIconLight":"sharedIconLight---C5Hpf"};